module.exports = __webpack_public_path__ + "static/media/join-students.7a112748.png";